import { RouterProvider, createRouter } from "@tanstack/react-router";

import { adminRouteTree } from "./routeTree";

export const router = createRouter({ routeTree: adminRouteTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function AdminRouterProvider() {
  return <RouterProvider router={router} />;
}
